import React, { useState } from 'react';
import { CaretLeftIcon, CaretRight, ICON_PATHS, Icon } from './icons';

import DeactivateModal from '../deactivate_modal/index_gated.jsx';

import styles from '../new_settings.module.css';

export function Section({ label, children, className = '' }) {
  return (
    <div className={`${styles.section} ${className}`}>
      {label && <p className={styles.section_label}>{label}</p>}
      <div className={styles.section_card}>{children}</div>
    </div>
  );
}

export function Row({ icon, label, sub, right, onClick, danger }) {
  const Tag = onClick ? 'button' : 'div';
  return (
    <Tag
      type={onClick ? 'button' : undefined}
      onClick={onClick}
      className={`${styles.row} ${onClick ? styles.row_clickable : ''}`}
    >
      {icon && (
        <span className={styles.row_icon}>
          <Icon path={icon} size={14} />
        </span>
      )}
      <span className={styles.row_text}>
        <span className={`${styles.row_label} ${danger ? styles.row_label_danger : ''}`}>{label}</span>
        {sub && <span className={styles.row_sub}>{sub}</span>}
      </span>
      {right ||
        (onClick && (
          <span className={styles.row_caret}>
            <CaretRight />
          </span>
        ))}
    </Tag>
  );
}

function ContactRow({ icon, label, value }) {
  return (
    <div className={styles.row}>
      <span className={styles.row_icon}>
        <Icon path={icon} size={14} />
      </span>
      <span className={styles.row_text}>
        <span className={styles.contact_label}>{label}</span>
        <span className={styles.contact_value} translate='no'>
          {value || '—'}
        </span>
      </span>
    </div>
  );
}

function SubpageHeader({ title, showBack, onBack }) {
  return (
    <div className={`${styles.subpage_header} ${styles.motion_item}`}>
      {showBack && (
        <button type='button' className={styles.subpage_back} onClick={onBack} aria-label='Back to settings'>
          <CaretLeftIcon className={styles.subpage_back_arrow} />
        </button>
      )}
      <h1 className={styles.subpage_title}>{title}</h1>
    </div>
  );
}

function DeactivateCard({ onOpen }) {
  return (
    <div className={styles.deactivate_card}>
      <div className={styles.deactivate_card_header}>
        <span className={styles.deactivate_icon_wrap}>
          <Icon path={ICON_PATHS.trash} size={16} />
        </span>
        <p className={styles.deactivate_title}>Delete your account?</p>
      </div>
      <p className={styles.deactivate_para}>
        This permanently removes your profile, conversations, and call history. This cannot be undone.
      </p>
      <button type='button' className={styles.deactivate_btn} onClick={onOpen}>
        Delete account
      </button>
    </div>
  );
}

export function AccountSubpage({ user, onManageProfile, showBack = false, onBack }) {
  const [showDeactivateModal, setShowDeactivateModal] = useState(false);

  return (
    <div className={styles.motion_stack}>
      <SubpageHeader title='Account' showBack={showBack} onBack={onBack} />
      <Section className={styles.motion_item}>
        <Row
          icon={ICON_PATHS.id}
          label='Manage profile'
          sub='Name, email, phone and password'
          onClick={onManageProfile}
        />
      </Section>
      <Section label='Contact info' className={styles.motion_item}>
        <ContactRow icon={ICON_PATHS.envelope} label='Email' value={user?.email} />
        <ContactRow icon={ICON_PATHS.phone} label='Phone' value={user?.phone} />
      </Section>
      <div className={styles.motion_item}>
        <DeactivateCard onOpen={() => setShowDeactivateModal(true)} />
      </div>
      {showDeactivateModal && <DeactivateModal setClickModal={setShowDeactivateModal} />}
    </div>
  );
}
